<template>
  <div class="hello uk-container">
    <div v-if="showResults" class="uk-text-center">
      <h3>Quiz Completed</h3>
      <h4>Score: {{ numberCorrect / total * 100 }}% ( {{ numberCorrect }} of 20 correct )</h4>
      <p class="uk-margin-large">
        <button class="uk-button uk-button-default" v-on:click="reset()">Try again</button>
      </p>
      <p class="uk-margin-large">
        <button class="uk-button uk-button-default" v-on:click="startReview()">Review Answers</button>
      </p>
    </div>
    <div v-else>
      <div>
        <transition name="slide-fade" mode="out-in">
          <div v-for="(question, index) in questions" v-if="index == current" :key="index">
            <div uk-grid>
              <div class="uk-width-1-4">
                <h4>Question {{ current + 1}} of {{ total }}</h4>
                <p>{{ stem(question) }}</p>
                <div v-for="answer in question.randomChoices">
                  <p v-if="!reviewIncorrect">
                    <label><input type="radio" :value="answer" v-model="radioModels[index]" :name="radioName(index)" v-on:click="select(answer)"> {{ answer }}</label>
                  </p>
                  <p v-else>
                    <span v-if="question.choices[answer]" class="correct">{{ answer }} (Correct)</span>
                    <span v-else-if="question.selectedAnswer == answer" class="wrong">{{ answer }} (Selected)</span>
                    <span v-else>{{ answer }}</span>
                  </p>
                </div>
              </div>
              <div class="uk-width-3-4" :style="frameStyle">
                <img :src="imageUrl(question)" :style="imageStyle"/>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="uk-margin-large" uk-grid>
        <div class="uk-width-1-4">
          <button v-show="current > 0" class="uk-button uk-button-default" v-on:click="retreat()">Previous</button>
        </div>
        <div class="uk-width-1-2 uk-text-center">
          <button v-show="(current == total - 1 && radioModels[current] != '') || reviewIncorrect" class="uk-button uk-button-default" v-on:click="finish()">Finish</button>
        </div>
        <div class="uk-text-right uk-width-1-4">
          <button v-show="current < total - 1 && radioModels[current] != ''" class="uk-button uk-button-default" v-on:click="advance()">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Quiz from '../Quiz.js'
import _ from 'lodash'

let MAX_HEIGHT = (window.innerHeight - 80 - 20 - 32 - 90)
const QUIZ_SIZE = '' + (MAX_HEIGHT > 756 ? 756 : MAX_HEIGHT) + 'px'
// viewport height minus navbar, margin, space for buttons

export default {
  data () {
    return {
      questions: Quiz.questions,
      total: Quiz.questions.length,
      current: 0,
      activeQuestion: Quiz.questions[0],
      choices: [],
      radioModels: Array(Quiz.questions.length).fill(''),
      showResults: false,
      reviewIncorrect: false,
      imageStyle: {
        maxHeight: QUIZ_SIZE
      },
      frameStyle: {
        height: QUIZ_SIZE
      }
    }
  },
  mounted () {
    let self = this
    this.questions = _.shuffle(Quiz.questions)
    this.questions = _.map(this.questions, function (question) {
      return Object.assign(question, {
        randomChoices: self.randomize(question.choices)
      })
    })
    this.setQuestion(0)
  },
  computed: {
    numberCorrect () {
      let choices = this.choices
      return _.filter(_.keys(choices), function (index) {
        let question = choices[index]
        return question.choices[question.selectedAnswer]
      }).length
    }
  },
  methods: {
    startReview () {
      this.reviewIncorrect = true
      this.showResults = false
      this.setQuestion(0)
    },
    radioName (index) {
      return 'question_' + index
    },
    imageUrl (question) {
      return 'static/imgs/' + question.img
    },
    stem (question) {
      return question.stem ? question.stem : 'Which of the following choices best describes the image:'
    },
    advance () {
      if (this.current + 1 < this.total) {
        this.setQuestion(this.current + 1)
      } else {
        if (confirm('This is the last question. Complete the quiz and view your results?')) {
          this.finish()
        }
      }
    },
    randomize (choices) { // takes a choices object, which has as keys, answer options, and as
      // values, boolean to represent answer correct or not
      // returns an array of answers choices
      return _.shuffle(_.keys(choices))
    },
    retreat () {
      this.setQuestion(this.current - 1 < 0 ? 0 : this.current - 1)
    },
    select (answer) {
      // do we need to do this... or would the radio models be good enough?
      this.$set(this.choices, this.current, Object.assign(this.activeQuestion, { selectedAnswer: answer }))
      this.advance()
    },
    finish () {
      this.showResults = true
    },
    setQuestion (index) {
      this.current = index
      this.activeQuestion = this.questions[this.current]
    },
    reset () {
      this.showResults = false
      this.choices = []
      this.reviewIncorrect = false
      this.radioModels = Array(this.total).fill('')
      this.setQuestion(0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrong {
  color: #f05050;
  font-weight: bold;
}

.correct {
  color: #50c050;
  font-weight: bold;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter {
  /* transform: translateX(20px); */
  opacity: 1.0;
}
.slide-fade-leave-to {
  /* transform: translateX(-20px); */
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Quiz.vue